export const BREAKPOINTS = {
  MINI: 320,
  MOBILE: 480,
  SMALL: 580,
  MEDIUM: 768,
  LARGE: 992,
  DEFAULT: 1439,
  MEGA: 1600,
} as const;
